var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4317 13.3378H24.0131M12.4317 19.1285H21.1178M26.9085 6.0994C28.0603 6.0994 29.165 6.55696 29.9795 7.37144C30.7939 8.18591 31.2515 9.29058 31.2515 10.4424V22.0238C31.2515 23.1757 30.7939 24.2803 29.9795 25.0948C29.165 25.9093 28.0603 26.3668 26.9085 26.3668H19.6701L12.4317 30.7099V26.3668H9.53639C8.38454 26.3668 7.27988 25.9093 6.4654 25.0948C5.65093 24.2803 5.19336 23.1757 5.19336 22.0238V10.4424C5.19336 9.29058 5.65093 8.18591 6.4654 7.37144C7.27988 6.55696 8.38454 6.0994 9.53639 6.0994H26.9085Z",
    stroke: "#7C42EE",
    strokeWidth: 2.12609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.64efd1ca6df5652ffe742c7a7d4f72ab.svg";
export { ForwardRef as ReactComponent };